import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="text-center">
        <div className="text-6xl font-bold text-primary-600 dark:text-primary-400 mb-4 transition-colors duration-300">404</div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4 transition-colors duration-300">Page not found</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-8 transition-colors duration-300">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="btn-primary"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
